import { render, staticRenderFns } from "./KGC.vue?vue&type=template&id=5b283185"
import script from "./KGC.vue?vue&type=script&lang=js"
export * from "./KGC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports